import { BackendError } from './BackendError';

// The backend node server itself is not available
export class ServerUncontactableError extends BackendError {
  static errorName = 'ServerUncontactableError';
}
